import { render, staticRenderFns } from "./SearchIADislikeDialogComponent.vue?vue&type=template&id=28d61768&scoped=true&lang=pug"
import script from "./SearchIADislikeDialogComponent.vue?vue&type=script&lang=ts"
export * from "./SearchIADislikeDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./SearchIADislikeDialogComponent.vue?vue&type=style&index=0&id=28d61768&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d61768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d61768')) {
      api.createRecord('28d61768', component.options)
    } else {
      api.reload('28d61768', component.options)
    }
    module.hot.accept("./SearchIADislikeDialogComponent.vue?vue&type=template&id=28d61768&scoped=true&lang=pug", function () {
      api.rerender('28d61768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/SearchIADislikeDialogComponent.vue"
export default component.exports